import i18n from 'i18next';

import { httpClient } from 'src/config/http';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { captureException } from 'src/shared/helpers/captureException';

export interface Consents {
    key: string;
    title: string;
    publishedVersion: string;
    url: string | null;
    required: boolean;
    acceptanceLanguage: string;
}

interface LegalContracts {
    key: string;
    group: number;
    contractsData: Consents[];
}

export class ClickwrapService {
    constructor(private toastNotificationsService: ToastNotificationsService) {}

    private handleError(message: string): void {
        this.toastNotificationsService.renderErrorToast(message);
    }

    public async fetchConsents(options: {
        country: string;
        language: string;
        skipCache?: boolean;
    }): Promise<LegalContracts> {
        try {
            const { skipCache, ...rest } = options;

            const parseOptions = {
                ...rest,
                skip_cache: (skipCache ?? false).toString(),
            };

            return httpClient.GET_UNAUTHENTICATED<LegalContracts>(
                `legal_contracts/member?${new URLSearchParams(parseOptions).toString()}`,
            );
        } catch (error) {
            captureException(error);
            this.handleError(i18n.t('translation:generic_error_screen.header'));

            return Promise.reject();
        }
    }
}
